export const styles = {
  container: 'flex-1 flex flex-col px-4 py-6 space-y-4',
  detailContainer: 'space-y-4',
  headerCard: 'bg-white rounded-xl border border-gray-200 shadow-sm p-6',
  headerTitle:
    'flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-2',
  title: 'text-2xl font-bold text-gray-900',
  headerSubtitle: 'text-sm text-gray-500',
  cardTitle:
    'text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-100',

  statusBadge:
    'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium',
  statusAwaitingPayment: 'bg-amber-100 text-amber-800',
  statusSettled: 'bg-green-100 text-green-800',
  statusCanceledRefund: 'bg-red-100 text-red-800',
  statusExpired: 'bg-gray-200 text-gray-800',
  statusError: 'bg-red-100 text-red-800',

  infoCard: 'bg-white rounded-xl border border-gray-200 shadow-sm p-6',
  infoGrid: 'grid grid-cols-1 sm:grid-cols-2 gap-4',
  infoItem: 'flex flex-col space-y-1',
  infoLabel: 'text-sm font-medium text-gray-600',
  infoValue: 'text-sm font-semibold text-gray-900',
  infoValueAmount: 'text-lg font-bold text-green-600',

  actionsContainer: 'flex flex-col sm:flex-row gap-3 mt-6',

  printButton:
    'h-16 w-full flex items-center justify-center bg-blue-600 text-white px-8 rounded-xl text-base font-semibold hover:bg-blue-700 transition-all duration-150 shadow-md hover:shadow-lg',
  backButton:
    'h-16 w-full flex items-center justify-center bg-black text-white px-8 rounded-xl text-base font-semibold hover:bg-gray-900 transition-all duration-150 shadow-md hover:shadow-lg',
} as const

export const texts = {
  title: 'Detalle venta',
  token: 'Token',
  amount: 'Monto',
  saleId: 'ID venta',
  payerPhone: 'Celular del Cliente',
  creationDate: 'Hora Transacción',
  bankName: 'Banco Origen',
  print: 'Imprimir',
  goBack: 'Regresar',
} as const
